import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { FloatingAdinkra } from '../components/Decorators';
import { RevealOnScroll } from '../hooks/useScrollReveal';

const ContactPage = () => (
  <div className="kente-section-bg" style={{ padding: '4rem 2rem', position: 'relative' }}>
    <FloatingAdinkra count={3} color="rgba(107, 85, 32, 0.04)" />
    <div style={{ maxWidth: '1100px', margin: '0 auto', position: 'relative', zIndex: 2 }}>
      <RevealOnScroll>
        <div className="section-header">
          <h2 className="section-title">Let's Collaborate</h2>
          <p className="section-subtitle">Build something extraordinary together</p>
        </div>
        <div className="kente-border"></div>
      </RevealOnScroll>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '1.5rem' }}>
        {[
          { icon: Mail, label: 'Email', value: 'adwoaacheampong728@gmail.com', href: 'mailto:adwoaacheampong728@gmail.com' },
          { icon: Phone, label: 'Phone', value: '+233 276 291 485', href: 'tel:+233276291485' },
          { icon: MapPin, label: 'Location', value: 'Accra, Ghana', href: '#' },
        ].map((item, idx) => {
          const Icon = item.icon;
          return (
            <RevealOnScroll key={idx} delay={idx * 200} direction="scale">
              <a href={item.href} style={{ textDecoration: 'none', color: 'inherit' }}>
                <div className="contact-card">
                  <Icon size={24} color="var(--gold)" />
                  <p style={{ margin: '0.6rem 0 0.3rem', fontWeight: 'bold', color: 'var(--gold-dark)', fontFamily: 'DM Sans, sans-serif', fontSize: '0.65rem', letterSpacing: '0.1em', textTransform: 'uppercase' }}>{item.label}</p>
                  <p style={{ color: 'var(--text-dark-secondary)', fontSize: '0.82rem' }}>{item.value}</p>
                </div>
              </a>
            </RevealOnScroll>
          );
        })}
      </div>
    </div>
  </div>
);

export default ContactPage;
